import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translations: { [key: string]: { [key: string]: string } } = {
    en: {
      ABOUT_YOU: 'Student Information',
      PARTICIPANT_TYPE: 'Are you a*',
      PLEASE_CHOOSE: 'Please Choose',
      NAME: 'Full Name',
      COUNTY: 'County where School is Located *',
      SCHOOL_NAME: 'Your School Name *',
      STUDENT_GENDER: 'Student Gender *',
      STUDENT_AGE: 'Student Age *',
      GRADE: 'Grade *',
      MALE: 'Male',
      FEMALE: 'Female',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      CANNOT_FIND: 'Cannot find your school?',

      // Teacher Info Translations
      TEACHER_INFO: 'Teacher Information',
      TEACHER_INFO_DESC: 'Required information about your Sponsoring Teacher and Head Teacher.',
      TEACHER_NAME: 'Name of Teacher-in-charge *',
      TEACHER_PHONE: 'Teacher In Charge Phone Number *',
      TEACHER_EMAIL: 'Teacher In Charge Email (optional)',
      PRINCIPAL_NAME: "Principal or Head Teacher's Name *",
      PRINCIPAL_PHONE: "School or Head Teacher's Phone",
      TEACHER_NAME_REQUIRED: 'Teacher name is required.',
      VALID_PHONE_REQUIRED: 'Valid phone number is required.',
      VALID_EMAIL_REQUIRED: 'Please enter a valid email address.',
      PRINCIPAL_NAME_REQUIRED: "Principal's name is required.",

      // Essay Editor Translations
      ESSAY_TITLE: 'Your Essay Title or Question:',
      ESSAY_CATEGORY: 'Essay Category *',
      UPLOAD_OPTION: 'I would like to upload my essay instead of typing it here.',
      WORD_COUNT: 'Word Count:',
      SAVE: 'Save',
      UPLOAD_ESSAY: 'Upload Essay',
      UPLOADED_FILE: 'Uploaded File:',
      EDITOR_PLACEHOLDER: 'Type your essay here...',

      // Confirm Page Translations
      DEC_RULES_TITLE: 'DEC Official Rules',
      DEC_RULES_DESC: 'Your essay will not be submitted unless you agree to the following statement and complete the form:',
      DEC_AGREEMENT: 'I confirm that I have read and agree with the DEC Official Rules *',
      SUBMIT: 'Submit',
      I_AGREE: 'I agree',

      // Status Page
      THANK_YOU_TITLE: 'Thank You for Your Entry!',
      THANK_YOU_MESSAGE: 'Your submission was successful!',
      JUDGING_INFO: 'Thank you for your entry! Your Submission was successful! The judging for the essays will take place in August and the Prize Giving is in September . Every student who participates will get feedback on their essay. However, only a Finalist or a Winner will be contacted by eKitabu staff to attend the Prize Giving or get a prize by an eKitabu staff. eKitabu wishes you all the best in the competition. Thank you. You can contact us at essaycontest@ekitabu.com or +254 740524629',
      BEST_WISHES: 'eKitabu wishes you all the best in the competition. Thank you.',
      CONTACT_INFO: 'You can contact us at <a href="mailto:essaycontest@ekitabu.com">essaycontest&#64;ekitabu.com</a> or call <strong>+254 740524629</strong>.'
    },
    sw: {
      ABOUT_YOU: 'Kuhusu Wewe na Shule Yako',
      PARTICIPANT_TYPE: 'Wewe ni*',
      PLEASE_CHOOSE: 'Tafadhali Chagua',
      NAME: 'Jina Kamili',
      COUNTY: 'Kaunti ambapo Shule Iko *',
      SCHOOL_NAME: 'Jina la Shule Yako *',
      STUDENT_GENDER: 'Jinsia ya Mwanafunzi *',
      STUDENT_AGE: 'Umri wa Mwanafunzi *',
      GRADE: 'Daraja *',
      MALE: 'Mwanaume',
      FEMALE: 'Mwanamke',
      PREVIOUS: 'Iliyopita',
      NEXT: 'Ifuatayo',
      CANNOT_FIND: 'Huwezi kupata shule yako?',

      // Teacher Info Translations
      TEACHER_INFO: 'Habari za Mwalimu',
      TEACHER_INFO_DESC: 'Taarifa muhimu kuhusu Mwalimu wako na Mkuu wa Shule.',
      TEACHER_NAME: 'Jina la Mwalimu Mkuu *',
      TEACHER_PHONE: 'Nambari ya Simu ya Mwalimu Mkuu *',
      TEACHER_EMAIL: 'Barua pepe ya Mwalimu Mkuu (hiari)',
      PRINCIPAL_NAME: 'Jina la Mkuu wa Shule *',
      PRINCIPAL_PHONE: 'Nambari ya Simu ya Mkuu wa Shule',
      TEACHER_NAME_REQUIRED: 'Jina la mwalimu linahitajika.',
      VALID_PHONE_REQUIRED: 'Nambari halali ya simu inahitajika.',
      VALID_EMAIL_REQUIRED: 'Tafadhali ingiza barua pepe halali.',
      PRINCIPAL_NAME_REQUIRED: 'Jina la mkuu wa shule linahitajika.',

      // Essay Editor Translations
      ESSAY_TITLE: 'Kichwa cha Insha Yako au Swali:',
      ESSAY_CATEGORY: 'Kategoria ya Insha *',
      UPLOAD_OPTION: 'Ningependa kupakia insha yangu badala ya kuandika hapa.',
      WORD_COUNT: 'Idadi ya Maneno:',
      SAVE: 'Hifadhi',
      UPLOAD_ESSAY: 'Pakia Insha',
      UPLOADED_FILE: 'Faili Iliyopakiwa:',
      EDITOR_PLACEHOLDER: 'Andika insha yako hapa...',

      // Confirm Page Translations
      DEC_RULES_TITLE: 'Sheria Rasmi za DEC',
      DEC_RULES_DESC: 'Insha yako haitawasilishwa hadi ukubaliane na taarifa ifuatayo na ukamilishe fomu:',
      DEC_AGREEMENT: 'Ninakubali kuwa nimeisoma na kuafikiana na Sheria Rasmi za DEC *',
      SUBMIT: 'Wasilisha',
      I_AGREE: 'Ninakubali',
      
      // Status Page
      THANK_YOU_TITLE: 'Asante kwa Kushiriki!',
      THANK_YOU_MESSAGE: 'Maombi yako yamefanikiwa!',
      JUDGING_INFO: 'Kuhakiki insha zako kutafanyika mnamo <strong>Agosti</strong>, na Utoaji wa Zawadi ni mnamo <strong>Septemba</strong>. Hata hivyo, ni <strong>Washindi</strong> au <strong>Washiriki wa Mwisho</strong> pekee watakaowasiliana na wafanyakazi wa eKitabu kuhudhuria Utoaji wa Zawadi au kupokea zawadi.',
      BEST_WISHES: 'eKitabu inakutakia kila la heri kwenye shindano. Asante.',
      CONTACT_INFO: 'Unaweza kuwasiliana nasi kupitia <a href="mailto:essaycontest@ekitabu.com">essaycontest&#64;ekitabu.com</a> au piga simu <strong>+254 740 524629</strong>.'
    }
  };

  private currentLanguage: string = 'en';

  setLanguage(lang: string) {
    this.currentLanguage = lang;
  }

  translate(key: string): string {
    return this.translations[this.currentLanguage][key] || key;
  }
}
